(function () {
  var LIMIT = 10000, busy = false, PV = 67726962524330;
  function net(cart) { var t = cart.total_price; cart.items.forEach(function (i) { if (i.variant_id === PV) t -= i.final_line_price; }); return t; }
  function fmt(c) { return '$' + (c / 100).toFixed(2); }
  function render(total, wrap) {
    var left = LIMIT - total;
    var pct = Math.min(100, Math.round(total * 100 / LIMIT));
    var msg = left > 0 ? 'You are <strong>' + fmt(left) + '</strong> away from <strong>free shipping</strong>' : '🎉 You qualify for <strong>free shipping</strong>';
    var inner = '<div class="colo-ship"><p>' + msg + '</p><div class="colo-ship__track"><span style="width:' + pct + '%"></span></div></div>';
    return '<div data-colo-ship class="' + (wrap ? 'page-width colo-ship-wrap' : 'colo-ship-drawer') + '">' + inner + '</div>';
  }
  function place() {
    if (busy) return; busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-colo-ship]').forEach(function (n) { n.remove(); });
      if (!cart.item_count) return;
      var page = document.querySelector('main .cart__contents, main cart-items');
      if (page) {
        var t = page.closest('.page-width') || page;
        t.insertAdjacentHTML('beforebegin', render(net(cart), true));
      }
      var drawer = document.querySelector('cart-drawer:not(.is-empty) .drawer__inner');
      if (drawer) {
        var first = drawer.querySelector('.drawer__header');
        if (first) first.insertAdjacentHTML('afterend', render(net(cart), false));
      }
    }).catch(function () {}).finally(function () { busy = false; });
  }
  document.addEventListener('DOMContentLoaded', place);
  var tm;
  new MutationObserver(function (muts) {
    if (muts.every(function (m) { return m.target.closest && m.target.closest('[data-colo-ship]'); })) return;
    clearTimeout(tm); tm = setTimeout(place, 350);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
